import { categories } from "@redotech/redo-model/advanced-flow/triggers";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const sendManualMessage = {
  name: "sendManualMessage" as const,
  input: z.object({
    conversationId: zExt.objectId(),
    content: z.string().min(1),
    category: createEnum(categories),
  }),
  output: z.object({
    success: z.boolean(),
    messageId: z.string().optional(),
    errorMessage: z.string().optional(),
  }),
};
